import PriceListTable from "@modules/navigator/views/PriceList/PriceListTable/PriceListTable.js";
import Navigator from "@modules/navigator/Navigator.js";
import Multiselect from "@modules/forms/Inputs/Select/Multiselect.js";
import Header from "@templates/Header/Header.js";
import AOS from "aos";
import App from "@templates/App/App.js";

const PriceList = {
    currentFloor: null,

    init(el) {
        this.el = $('[page="PriceList"].PriceList');

        if (!this.el.length) {
            return;
        }

        this.floorSelect = this.el.find("[component].FloorSelect select");
        this.skeleton = this.el.find(".loading");

        this.start();
        this.bind();
    },

    start() {
        Navigator.view = 'pricelist';
        this.currentFloor = this.floorSelect.val();
        this.Filters.init(this.el);
        PriceListTable.init();

        if (!App.isMobile) {
            $('[url="byty-a-nebytove-priestory/cennik"] [block="menu"] .sub').hide();
        } else {
            $('[url="byty-a-nebytove-priestory/cennik"] [block="menu"] [method="renderMenu"]').hide();
        }
    },

    bind() {
        this.floorSelect.off('change').on('change', Navigator.debounce((evt) => this.changeFloor(evt), 100));
    },

    changeFloor(evt) {
        const value = $(evt.currentTarget).val();

        if (value === '0') {
            // Navigator.Router.removeFloorFromUrl();
            return;
        }

        // console.log(value);
        // Navigator.Router.appendFloorToUrl(value, '/byty/cennik/', false);
    },

    Filters: {
        previousFloor: null,

        init(el) {
            this.el = el.find("form.filter");

            this.tableView = el.find(".table-view .table");
            this.rangeFiltersView = el.find(".range-filters-view");
            this.floorFilter = el.find(".filter-floor");
            this.roomFilter = el.find(".filter-room")
            this.flatTypeSelect = el.find(".filter-type");
            this.resetButtonsView = el.find('.reset-bar');
            this.buttonReset = this.el.find('button[type="reset"]');

            this.stateFilter = this.el.find('input[type="radio"][name="state"]');


            // this.start();
            this.prepare();
            this.bind();
        },

        prepare() {
            this.prepareRangeSlider(this.rangeFiltersView.find('.price-range .input'));
            this.prepareRangeSlider(this.rangeFiltersView.find('.area-range .input'));

            this.el.each((function (i, el) {
                Multiselect.init($(el));
            }));
        },

        bind() {
            this.el.off('change').on('change', (evt) => PriceListTable.Table.showLoading(true));
            this.el.on('change', Navigator.debounce((evt) => this.submitFilter(evt), 250));

            this.buttonReset.off('click').on('click', Navigator.debounce((evt) => this.cancelFilter(evt), 250));

            let lastCheckedState = this.stateFilter.filter((index, el) => $(el).is(":checked"));
            this.stateFilter.on('click', Navigator.debounce((evt) => {
                const button = $(evt.currentTarget);

                if (lastCheckedState && button[0] === lastCheckedState[0]) {
                    lastCheckedState = null;
                    button.prop("checked", false).trigger('change');
                } else {
                    lastCheckedState = button;
                }
            }));

            this.bindResetButtons();
        },

        bindResetButtons() {
            this.resetButtonsView.find('button').on('click', Navigator.debounce((evt) => this.resetFilter(evt), 1));
        },

        prepareRangeSlider(input) {
            if (!input.length) {
                return;
            }
            const data = input.data();
            const inputFrom = input.parent().find('.from');
            const inputTo = input.parent().find('.to');

            const defaultFrom = inputFrom.val() || data.min;
            const defaultTo = inputTo.val() || data.max;

            // console.log(inputFrom.val() || data.min);
            // console.log(inputTo.val() || data.max)
            input.slider({
                range: true,
                min: data.min,
                max: data.max,
                values: [
                    defaultFrom,
                    defaultTo
                ],
                slide: function (event, ui) {
                    inputFrom.val(ui.values[0]);
                    inputTo.val(ui.values[1]);

                    PriceList.Filters.el.trigger("change");

                    input.find(".ui-slider-handle").first().attr("value", ui.values[0]);
                    input.find(".ui-slider-handle").last().attr("value", ui.values[1]);
                }
            });

            input.find(".ui-slider-handle").first().attr("value", defaultFrom);
            input.find(".ui-slider-handle").last().attr("value", defaultTo);
        },

        resetSlider(input, nullValues = false) {
            if (!nullValues) {
                this.prepareRangeSlider(input);
            }

            const data = input.data();
            const inputFrom = input.parent().find('.from');
            const inputTo = input.parent().find('.to');

            if (nullValues) {
                inputFrom.removeAttr('value');
                inputTo.removeAttr('value');
            } else {
                inputFrom.val(nullValues ? 0 : data.min);
                inputTo.val(nullValues ? 0 : data.max);
            }
        },

        submitFilter(evt) {
            const formData = this.formData();

            this.updateUrlPath(formData);

            $.ajax({
                type: 'POST',
                url: WEB_ROOT + '/modules/navigator/Navigator.async.php',
                data: formData,
                dataType: "json",
                processData: false,
                contentType: false,

                success: (response, textStatus, jqXHR) => {
                    this.tableView.html(response.view_table);

                    if (response.view_floor_filter) {
                        this.floorFilter.html(response.view_floor_filter);
                    }

                    if (response.view_room_filter) {
                        this.roomFilter.html(response.view_room_filter);
                    }

                    if (response.view_type_filter) {
                        this.flatTypeSelect.html(response.view_type_filter);
                    }

                    this.rangeFiltersView.html(response.view_range_filters);

                    PriceList.Filters.init(PriceList.el);
                    PriceListTable.init();
                    PriceList.currentFloor = formData.get('floor');

                    AOS.refresh();
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    console.error('AJAX Error:', textStatus, errorThrown);
                    console.log('Response Text:', jqXHR.responseText); // Log the response text for debugging
                }
            });
        },

        formData(action = 'price-list-table') {
            let formData = new FormData();
            formData.append('action', action);

            const processedRadioNames = new Set();

            this.el.find("input, select").each((index, input) => {
                const $input = $(input);
                const name = $input.attr("name");
                let value = $input.val();

                if (!name) return;

                if ($input.is('[type="checkbox"]')) {
                    value = $input.is(':checked') ? 1 : 0;
                    formData.append(name, value);
                } else if ($input.is('[type="radio"]')) {
                    if (processedRadioNames.has(name)) return;

                    const $checked = this.el.find(`input[name="${name}"]:checked`);
                    if ($checked.length) {
                        formData.append(name, $checked.val());
                    }
                    processedRadioNames.add(name);
                } else {
                    formData.append(name, value);
                }
            });

            return formData;
        },

        updateUrlPath(formData) {
            // Convert form data to query string
            const params = new URLSearchParams();
            const ignoredParams = ['action'];

            for (const [key, value] of formData.entries()) {

                if (ignoredParams.includes(key)) {
                    continue;
                }

                // if (key === 'rooms' && value === '0') {
                //     continue;
                // }

                if ((key === 'priceTo' || key === 'priceFrom' || key === 'totalAreaTo' || key === 'totalAreaFrom') && value === '0') {
                    continue;
                }

                if (value) {
                    params.set(key, value);
                } else {
                    params.delete(key);
                }
            }

            // Update URL without reloading the page
            if (params) {
                const newUrl = `${window.location.pathname}?${params.toString()}`;
                window.history.replaceState(null, '', newUrl);
            }

            // this.previousFloor = formData.get('floor');
        },

        cancelFilter(evt) {
            const form = $(evt.currentTarget).parents().closest("form");

            if (form.is(".range-filters")) {
                this.resetRangeSliders();
            }

            if (form.is(".checkbox-filter")) {
                form.find("input").prop("checked", false).removeAttr("checked");
            }

            form.trigger("reset");
            this.el.trigger("change");
        },

        resetFilter(evt) {
            const type = $(evt.currentTarget).data('form');

            $(evt.currentTarget).prop("disabled", true);

            switch (type) {
                case 'reset-floor':
                    $(".FloorSelect select").val(0);
                    break;

                case 'reset-room':
                    $(".RoomSelect select").val(0);
                    break;

                case 'reset-type':
                    $(".FlatTypeSelect select").val(0);
                    break;

                case 'reset-price':
                    this.resetSlider(this.el.find('.price-range .input'), true);
                    break;

                case 'reset-area':
                    this.resetSlider(this.el.find('.area-range .input'), true);
                    break;

                case 'reset-checkbox':
                    $(".checkbox-filter input").prop("checked", false).removeAttr("checked");
                    break;

                case 'reset-state':
                    $(".filter-state input").prop("checked", false).removeAttr("checked");
                    break;
            }

            this.el.trigger("change");
        },

        resetRangeSliders() {
            this.resetSlider(this.el.find('.price-range .input'));
            this.resetSlider(this.el.find('.area-range .input'));
        }
    },
}

export default PriceList;